module.exports = __webpack_public_path__ + "img/blue.60612ee5.png";